import { fixEncoderSize, transformEncoder, VariableSizeEncoder } from '@wiko/codecs-core';
import { getArrayEncoder, getBytesEncoder } from '@wiko/codecs-data-structures';
import { getShortU16Encoder } from '@wiko/codecs-numbers';
import { WIKO_ERROR__TRANSACTION__CANNOT_ENCODE_WITH_EMPTY_SIGNATURES, WikoError } from '@wiko/errors';
import { SignatureBytes } from '@wiko/keys';

import { SignaturesMap } from '../transaction';

function getSignaturesToEncode(signaturesMap: SignaturesMap): SignatureBytes[] {
    const signatures = Object.values(signaturesMap);
    if (signatures.length === 0) {
        throw new WikoError(WIKO_ERROR__TRANSACTION__CANNOT_ENCODE_WITH_EMPTY_SIGNATURES);
    }

    return signatures.map(signature => {
        if (!signature) {
            return new Uint8Array(64).fill(0) as SignatureBytes;
        }
        return signature;
    });
}

export function getSignaturesEncoder(): VariableSizeEncoder<SignaturesMap> {
    return transformEncoder(
        getArrayEncoder(fixEncoderSize(getBytesEncoder(), 64), { size: getShortU16Encoder() }),
        getSignaturesToEncode,
    );
}
